require('../../modules/es6.array.find-index');

module.exports = require('../../modules/_core').Array.findIndex;